import { render } from "./AuthLinks.vue?vue&type=template&id=3173d28e&scoped=true"
import script from "./AuthLinks.vue?vue&type=script&lang=js"
export * from "./AuthLinks.vue?vue&type=script&lang=js"

import "./AuthLinks.vue?vue&type=style&index=0&id=3173d28e&lang=scss&scoped=true"

import exportComponent from "/builds/blat/bcard-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3173d28e"]])

export default __exports__